

























import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import CardHeader from '@/components/Registration/Header.vue';
import Container from '@/components/Registration/Container.vue';
import RegistrationCard from '@/components/Registration/Card.vue';
import RegistrationFooter from '../Registration/SignupFooter.vue';
@Component({
  components: {
    CardHeader,
    Container,
    RegistrationCard,
    RegistrationFooter,
  },
})
export default class RoleRegisterList extends Vue {
  get tagLine() {
    return vxm.configs.getGlobalConfigValue('WL_COMPANY_TAG_LINE')
  }

  get roles() {
    return [
      {
        name: 'Pilots',
        signupLink: '/pilotSignup',
        text: 'Pilots - Register Now',
      },
      {
        name: 'Engineers',
        signupLink: '/engineerSignup',
        text: 'Engineers - Register Now',
      },
      {
        name: 'Others',
        signupLink: '/otherSignup',
        text: 'Other - Register Now',
      },
    ];
  }
}
